import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30766381")

_pushScopeId("data-v-30766381")
const _hoisted_1 = { class: "list-main-container" }
const _hoisted_2 = { class: "list-input-group" }
const _hoisted_3 = {
  class: "list-label",
  for: "list-input"
}
const _hoisted_4 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_5 = { class: "list-label-desc" }
const _hoisted_6 = { class: "list-input-container" }
const _hoisted_7 = { class: "list-list-container" }
const _hoisted_8 = { class: "list-item" }
const _hoisted_9 = { class: "list-item-details" }
const _hoisted_10 = {
  key: 0,
  class: "list-item-remove"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "list-item-remove-text" }, "remove", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_plusSVG = _resolveComponent("plusSVG")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, [
        _createVNode("strong", null, [
          _createTextVNode(_toDisplayString(_ctx.header) + " ", 1),
          (_ctx.required === true)
            ? (_openBlock(), _createBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.description), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.current = $event)),
          type: "text",
          "aria-label": `Enter the ${_ctx.listTypeName}`,
          placeholder: `Enter the ${_ctx.listTypeName}`
        }, null, 8, ["aria-label", "placeholder"]), [
          [_vModelText, _ctx.current]
        ]),
        _createVNode(_component_Button, {
          text: "Add",
          type: "button",
          disabled: _ctx.disabled,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.add()))
        }, null, 8, ["disabled"])
      ])
    ]),
    _createVNode("ul", _hoisted_7, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listInternal, (item, index) => {
        return (_openBlock(), _createBlock("li", {
          key: index,
          tabindex: "0",
          role: "button",
          "aria-pressed": "false",
          onClick: ($event: any) => (_ctx.remove(item.uin || item))
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(item.name || item) + " ", 1),
              (item.uin)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("(" + _toDisplayString(item.uin) + ")", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.disabled)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_plusSVG, {
                    class: "list-item-remove-icon",
                    alt: "remove"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ], 8, ["onClick"]))
      }), 128))
    ])
  ]))
})